import { render, staticRenderFns } from "./invoiceVatSummaryPrint.vue?vue&type=template&id=3fc347fd&"
import script from "./invoiceVatSummaryPrint.vue?vue&type=script&lang=ts&"
export * from "./invoiceVatSummaryPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports